export const prepareSaveData = (request) => {
  const formData = new FormData();
  const fieldMapping = {
    fullName: "fullName",
    phone: "phone",
    city: "city",
    state: "state",
    zip: "zip",
    country: "country",
    email: "email",
    requisitionNumber: "requisitionNumber",
    positionTitle: "positionTitle",
    action: "action",
  };
  var keys = Object.keys(fieldMapping);
  formData.append(
    "file",
    request.candidate_resume &&
      request.candidate_resume.length &&
      request.candidate_resume[0].size
      ? request.candidate_resume[0]
      : ""
  );
  formData.append(
    "fileName",
    request.candidate_resume && request.candidate_resume.length > 0
      ? request.candidate_resume[0].name
      : ""
  );
  keys.forEach((i) => {
    formData.append(i, request[fieldMapping[i]]);
  });
  return formData;
};
